import { gql } from "graphql-tag"

import { DEFAULTS } from "@/graphql/schemas/shared/utils/defaults"

const typeProductStock = gql`
  type ProductStock {
    branchId: String
    branchName: String
    availableStocks: Float
    sku: String
    quantityOnStock: Float
    reservedStock: Float
    orderedQuantity: Float
  }

  type ProductStocks {
    total: Int
    items: [ProductStock]
  }

  type Query {
    productStock(
        sku: ID!
        branchId: ID!
        lang: String = ""
        cdn: Boolean = true
    ): ProductStock

    productStocks(
        sku: ID!
        lang: String = ""
        cdn: Boolean = true
        offset: Int = ${DEFAULTS.QUERY.OFFSET}
        limit: Int = ${DEFAULTS.QUERY.MAX_LIMIT}
    ): ProductStocks
  }
`

export { typeProductStock }

export default typeProductStock
